import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function HiveIcon(props: IconProps) {
    return <Icon {...props} iconKey={"hive"}/>
}
